import { ContentCardVariant } from '@/components/organisms';

import { ContentTypeVariations, type CardDataType } from './types';

import type { PersonalPlaylist } from '@/lib/api';

export function makeCarouselItems<
  T extends { title: string },
  ImgKey extends keyof T,
  IdKey extends keyof T,
>(
  items: T[],
  contentType: ContentTypeVariations,
  imageField: ImgKey,
  idField: IdKey,
  variant: ContentCardVariant,
  fetchPersonalPlaylistWithTracks?: (
    playlistId: string | number,
  ) => Promise<PersonalPlaylist | null>,
): CardDataType[] {
  return items.map(item => ({
    id: item[idField] as number | string,
    title: item.title,
    contentType,
    description: '',
    imageUrl: String(item[imageField]),
    variant,
    rawData:
      contentType === ContentTypeVariations.LIBRARY
        ? (item as unknown as PersonalPlaylist)
        : undefined,
    fetchPersonalPlaylistWithTracks,
  }));
}
